import type { AxiosResponse } from 'axios';
import client from 'api/client';
import type { ActivityEvent } from 'types';

export const get = (case_id: string): Promise<AxiosResponse<ActivityEvent[]>> => {
    return client.get<ActivityEvent[]>(`/file-history/${case_id}`);
};
